import {FormField, Input, InputField} from "@hosttools/frontend/components";
import type React from "react";
import {memo, useCallback} from "react";

import type {CredentialsType, Errors} from "@/admin/components/ModalAddAccount/types";

type Props = {
    credentials: CredentialsType;
    errors?: Errors;
    onChangeCredentials: (field: "apiKey", value: string) => void;
};

const HoufyCredential: React.FC<Props> = ({credentials, errors, onChangeCredentials}) => {
    const handleChangeAPIKey = useCallback(
        (text: string) => {
            onChangeCredentials("apiKey", text);
        },
        [onChangeCredentials]
    );

    return (
        <FormField
            error={errors?.apiKey}
            label="API Access Token"
            tooltip="Enter your Houfy API key."
        >
            <Input isRequired>
                <InputField
                    autoComplete="off"
                    id="apiKey"
                    name="apiKey"
                    placeholder="API Access Token..."
                    testID="apiKey"
                    value={credentials.apiKey}
                    onChangeText={handleChangeAPIKey}
                />
            </Input>
        </FormField>
    );
};

export default memo(HoufyCredential);
